<template>
  <div id="app">
    <navbar class="d-print-none"></navbar>
    <div class="text-center d-none d-print-block">
      <h1 class="navbar-brand"><a href="#">Embers<span>Images</span></a></h1>
      <br>
    </div>
    <router-view></router-view>
    <vue-progress-bar></vue-progress-bar>
    <ez-scroll-to-top></ez-scroll-to-top>
  </div>
</template>

<script>
import EzScrollToTop from "@/mixins/vue-ez-scroll-to-top";
import Navbar from "@/components/Navbar";
import { mapState } from "vuex";

export default {
  name: "app",
  components: {
    Navbar
  },
  mixins: [EzScrollToTop],
  created() {
    this.$http.defaults.baseURL = process.env.VUE_APP_API_URL;
    this.setToken();
  },
  watch: {
    accessToken: "setToken"
  },
  computed: mapState({
    accessToken: state => state.session.accessToken
  }),
  methods: {
    setToken() {
      this.$http.defaults.headers.common[
        "Authorization"
      ] = this.$store.getters.bearerToken;
    }
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css">
</style>

<style>
@import "~simplemde/dist/simplemde.min.css";
</style>
